export default __webpack_public_path__ + "static/UElogowhite-a4d460d228a984ddfe252ec1f83c6a39.png";